// @flow
import styled from 'styled-components';

export const Tabs = styled.ul`
	display: flex;
	text-align: center;
	align-items: center;
	height: 40px;
	box-sizing: border-box;
	margin-bottom: 20px;
`;

export default Tabs;


// WEBPACK FOOTER //
// ./src/components/Tabs/index.js